import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faInfoCircle,
  faCheckCircle,
  faExclamationCircle,
  faTimes,
  faExclamationTriangle
} from '@fortawesome/pro-solid-svg-icons';
import { titleAndAria } from "protocol-setup/constants/errorMessages";
import { messageService } from "./eventBus";


export const NotificationContainer = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(null);
  const [type, setType] = useState(null);
  const [align, setAlign] = useState(null);
  const [placement, setPlacement] = useState(null);
  const iconSet = {
    default: faInfoCircle,
    success: faCheckCircle,
    error: faExclamationCircle,
    warning: faExclamationTriangle
  };
  useEffect(() => {
    const setupNotification = (props) => {
      setOpen(true);
      setMessage(props.message);
      setType(props.type);
      setAlign(props.align);
      setPlacement(props.location);
      setTimeout(() => {
        setOpen(false);
      }, props.displayTimeInSec * 1000);
    };
    messageService.on("open-notification", setupNotification);
    return () => {
      messageService.off("open-notification", setupNotification);
    };
  }, []);

  return (
    <div>
      {open ? (
        <div
          className={`ToasterNotification-wrapper ToasterNotification-${type} ToasterNotification-${align} ToasterNotification-${placement} ${type==='for-screen-reader'? 'sr-only' : ''}`}
          role="alert"
          aria-live="assertive"
        >
          <button
            type="button"
            className="ToasterNotification-fn-btn close"
            title={titleAndAria.closeNotification}
            onClick={() => {
              setOpen(false);
            }}
          >
          <FontAwesomeIcon icon={faTimes} />
          </button>
          <div className="ToasterNotification-content">
            <span className="ToasterNotification-icon">
              <FontAwesomeIcon icon={iconSet[type]} />
            </span>
            <span className="ToasterNotification-message">{message}</span>
          </div>
        </div>
      ) : null}
    </div>
  );
};
